import _ from 'lodash';
import {default_dfp_config} from './dfp_config_default';

const config = default_dfp_config;
config.ad_config_id = 0;
config.ad_config_name = 'e4e';
config.is_coppa = false;
config.is_hb = true;

const targetingMap = {};
config.targetingMap = targetingMap;
export default config;
